import { Rectangle } from "../../maths/Rectangle";
import { WrapMode } from "../../RenderEngine/RenderEnum/WrapMode";
import { ClassUtils } from "../../utils/ClassUtils";
import { genTileMesh } from "./MeshFactory";
export class TileMesh {
    constructor() {
        this.repeatX = true;
        this.repeatY = true;
    }
    onPopulateMesh(vb) {
        let tex = vb.mainTex;
        if (tex != null
            && vb.uvRect.x == 0 && vb.uvRect.y == 0 && vb.uvRect.width == 1 && vb.uvRect.height == 1
            && tex.bitmap.wrapModeU == WrapMode.Repeat
            && tex.bitmap.wrapModeV == WrapMode.Repeat) {
            let tmpRect = Rectangle.create();
            tmpRect.copyFrom(vb.uvRect);
            if (this.repeatX)
                tmpRect.width *= vb.contentRect.width / tex.width;
            if (this.repeatY)
                tmpRect.height *= vb.contentRect.height / tex.height;
            vb.addQuad(vb.contentRect, null, tmpRect);
            vb.triangulateQuad(0);
            tmpRect.recover();
        }
        else {
            genTileMesh(vb, vb.contentRect, vb.uvRect, tex ? tex.sourceWidth : vb.contentRect.width, tex ? tex.sourceHeight : vb.contentRect.height, this.repeatX, this.repeatY);
        }
    }
}
ClassUtils.regClass("TileMesh", TileMesh);
